<template>
  <Dialog :visible="visible" modal :closable="false" :show-header="false">
    <h2>Save changes before moving on?</h2>
    <p>
      If you don't save changes to scenario {{ scenarioTitle }}, your changes
      will be lost.
    </p>
    <div class="flex justify-content-between gap-2 mt-4">
      <Button
        label="Cancel"
        @click="() => handleConfirmed(DiscardAction.CANCEL)"
      />
      <Button
        label="Continue without saving"
        @click="
          () => {
            handleConfirmed(DiscardAction.DISCARD);
          }
        "
      />
      <Button
        label="Save and continue"
        class="p-button-info"
        @click="
          () => {
            handleConfirmed(DiscardAction.SAVE);
          }
        "
      />
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { DiscardAction } from "@/utils/enums";

defineProps<{
  visible: boolean;
  scenarioTitle: string;
}>();

const handleConfirmed = (action: DiscardAction) => {
  emit("confirmed", action);
};

const emit = defineEmits<{
  (e: "confirmed", value: DiscardAction): void;
}>();
</script>
